<div
	class="c-portlet u-bg-main u-shadow-mini {{ sectionclass }}"
	style="position: relative"
	(window:resize)="onResize($event)"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="analytics-campaign-charts-header c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini map-header-padding"
	>
		<div class="o-stack__cell">
			<h5>{{ sectiontitle }}</h5>
		</div>
	</div>
	<div class="c-portlet__content pos-relative" style="height: 580px">
		<div>
			<div class="map-wrapper">
				<div id="map" style="width: 100%; height: 580px"></div>
				<div id="geofence-disclaimer" class="geofence-disclaimer">
					<div class="geofence-disclaimer-section">
						<img class="geofence-disclaimer-img" src="../../../../../../assets/images/info-circle.png" />
						<span class="geofence-disclaimer-text"
							>Geofence/geo recency points may not display due to category-specific privacy restrictions in a selected
							campaign.</span
						>
					</div>
				</div>
			</div>
			<!--Legend starts here-->
			<div class="map-products-container" *ngIf="mapObj?.legend?.length > 0 && !this.isDOOH">
				<h5 class="map-products-title">Click on products to see coverage:</h5>
				<div class="map-products-list">
					<div
						class="map-product-item {{ legendItem.productName }}"
						*ngFor="let legendItem of mapObj?.legend"
						[ngClass]="{ 'map-product-item-selected': legendItem.isSelected, 'disable-button': legendItem.isDisabled }"
						(click)="selectedProductDetails(legendItem)"
					>
						<span>{{ legendItem.productName }}</span>
					</div>
				</div>
			</div>
			<!--Legend ends here-->

			<div
				class="map-region-container"
				*ngIf="polygonLayerDetails && showPolygonLayerDetailsFlag && !showGeofenceCenterDetailsFlag"
			>
				<div class="map-region-lift-detail-container" *ngIf="polygonLayerDetails.showLift">
					<!-- Show Lift -->
					<div class="map-region-lift" *ngIf="polygonLayerDetails.avgLift">
						Lift: {{ polygonLayerDetails.avgLift }}x
					</div>
					<div class="map-region-dmographic-value" *ngIf="!polygonLayerDetails.avgLift">
						Additional data required to calculate lift
					</div>

					<!-- Show Average Home Value -->
					<div class="map-region-dmographic-container margin-20pt">
						<span class="map-region-dmographic-title">
							<i
								*ngIf="polygonLayerDetails.showAvgHomeStar && polygonLayerDetails.avgHomeValue"
								class="fa fa-star left-3p"
								aria-hidden="true"
							></i
							>Avg Home Value:
						</span>
						<span *ngIf="polygonLayerDetails.avgHomeValue" class="map-region-dmographic-value"
							>${{ polygonLayerDetails.avgHomeValue | formatNumber }}</span
						>
						<span *ngIf="!polygonLayerDetails.avgHomeValue" class="map-region-dmographic-value">--</span>
					</div>
					<div *ngIf="polygonLayerDetails.avgHomeValue" class="map-region-dmographic-percent-value">
						{{ polygonLayerDetails.percentageAvgHomeValue }}% Avg
					</div>

					<!-- Show Average Median Age -->
					<div class="map-region-dmographic-container">
						<span class="map-region-dmographic-title">
							<i
								*ngIf="polygonLayerDetails.showAvgMedianAgeStar && polygonLayerDetails.avgMedianAge"
								class="fa fa-star left-3p"
								aria-hidden="true"
							></i
							>Median Age:
						</span>
						<span *ngIf="polygonLayerDetails.avgMedianAge" class="map-region-dmographic-value">{{
							polygonLayerDetails.avgMedianAge
						}}</span>
						<span *ngIf="!polygonLayerDetails.avgMedianAge" class="map-region-dmographic-value">--</span>
					</div>
					<div *ngIf="polygonLayerDetails.avgMedianAge" class="map-region-dmographic-percent-value">
						{{ polygonLayerDetails.percentageAvgMedianAge }}% Avg
					</div>

					<!-- Show Average Income -->
					<div class="map-region-dmographic-container">
						<span class="map-region-dmographic-title">
							<i
								*ngIf="polygonLayerDetails.showAvgIncomeStar && polygonLayerDetails.avgIncome"
								class="fa fa-star left-3p"
								aria-hidden="true"
							></i
							>Avg Income:
						</span>
						<span *ngIf="polygonLayerDetails.avgIncome" class="map-region-dmographic-value"
							>${{ polygonLayerDetails.avgIncome | formatNumber }}</span
						>
						<span *ngIf="!polygonLayerDetails.avgIncome" class="map-region-dmographic-value">--</span>
					</div>
					<div *ngIf="polygonLayerDetails.avgIncome" class="map-region-dmographic-percent-value">
						{{ polygonLayerDetails.percentageAvgIncome }}% Avg
					</div>

					<!-- Show Average Occupancy -->
					<div class="map-region-dmographic-container">
						<span class="map-region-dmographic-title">
							<i
								*ngIf="polygonLayerDetails.showAvgOccupancyStar && polygonLayerDetails.avgOccupancy"
								class="fa fa-star left-3p"
								aria-hidden="true"
							></i
							>Avg# per household:
						</span>
						<span *ngIf="polygonLayerDetails.avgOccupancy" class="map-region-dmographic-value">{{
							polygonLayerDetails.avgOccupancy
						}}</span>
						<span *ngIf="!polygonLayerDetails.avgOccupancy" class="map-region-dmographic-value">--</span>
					</div>
					<div *ngIf="polygonLayerDetails.avgOccupancy" class="map-region-dmographic-percent-value">
						{{ polygonLayerDetails.percentageAvgOccupancy }}% Avg
					</div>
				</div>
				<div class="map-region-dmographic-title margin-10pb">{{ polygonLayerDetails.regionName }}</div>
				<div class="map-region-detail-container">
					<span class="map-region-dmographic-title">Postal Code: </span>
					<span class="map-region-dmographic-value">{{ polygonLayerDetails.zip }}</span>
				</div>
				<div class="map-region-detail-container">
					<span class="map-region-dmographic-title">Population: </span>
					<span class="map-region-dmographic-value">{{ polygonLayerDetails.population }}</span>
				</div>
			</div>
			<div class="map-region-container dooh" *ngIf="isDOOH">
				<div class="header_controllers">
					<div class="selected-count">{{ doohGeoRecencyData?.features?.length }} Selected</div>
					<div class="action-links">
						<a
							href="javascript:void(0);"
							(click)="selectAll()"
							[class.disabled]="doohGeoRecencyData?.features?.length === doohData?.features?.length"
							>Select All</a
						>
						<a
							href="javascript:void(0);"
							(click)="clearAll()"
							[class.disabled]="doohGeoRecencyData?.features?.length === 0"
							>Clear All</a
						>
					</div>
				</div>
				<div *ngFor="let feature of doohData?.features; trackBy: trackByRegionId" class="map-region-details">
					<div class="map-region-detail-container">
						<input
							type="checkbox"
							[id]="feature.properties.id"
							[(ngModel)]="selectedItems[feature.properties.id]"
							(change)="onCheckboxChange($event, feature)"
							class="styled-checkbox"
						/>
						<span class="checkmark"></span>
						<label [for]="feature.properties.id">
							<span class="dot" [ngStyle]="{ 'background-color': feature.properties.venue_color }"></span>
							<span class="venue_name">{{ feature.properties.venue_type_1 }}</span>
						</label>
					</div>
				</div>
			</div>

			<div class="map-details-container" *ngIf="!isR103">
				<div class="map-details-wrapper">
					<div class="map-region-dmographic-title" style="line-height: 18px">
						{{ geofenceCenterDetails ? geofenceCenterDetails.name : '' }}
					</div>
				</div>
				<div class="details-map-container">
					<div id="minimap" style="height: 200px"></div>
				</div>
				<div class="map-details-wrapper">
					<div class="imprs-container">
						<span *ngIf="!isR104" class="imprs-value">{{
							geofenceCenterDetails ? geofenceCenterDetails.total_impression_sum : ''
						}}</span>
						<span *ngIf="isR104" class="imprs-value">{{
							geofenceCenterDetails ? (geofenceCenterDetails.total_impression_sum | formatNumber) : ''
						}}</span>
						<span class="imprs-text">Imprs</span>
					</div>
					<div class="map-region-detail-container">
						<span class="map-region-dmographic-value"
							>{{ geofenceCenterDetails ? geofenceCenterDetails.click_through_rate : '' }}% CTR&nbsp;&nbsp;</span
						>
						<span class="map-region-dmographic-value"
							>&nbsp;&nbsp;{{ geofenceCenterDetails ? geofenceCenterDetails.total_click_sum : '' }} Clicks</span
						>
					</div>
					<hr style="margin: 15px 0px" />
					<div class="map-region-detail-container">
						<span class="map-region-dmographic-value"
							>{{ geofenceCenterDetails ? geofenceCenterDetails.total_android : '' }}%
							<i class="fa fa-android" aria-hidden="true"></i>&nbsp;&nbsp;</span
						>
						<span class="map-region-dmographic-value"
							>&nbsp;&nbsp;{{ geofenceCenterDetails ? geofenceCenterDetails.total_ios : '' }}%
							<i class="fa fa-apple" aria-hidden="true"></i
						></span>
					</div>
				</div>
			</div>
			<!-- R103 map styles starts -->
			<div class="details-map-container-r103 map-details-container" *ngIf="isR103">
				<div id="minimap" style="height: 200px"></div>
			</div>
			<div class="map-details-container-r103 map-details-container" *ngIf="isR103 || isR8">
				<h5 class="map-subtitle">Geofence Location</h5>
				<div class="map-details-wrapper">
					<div class="map-region-dmographic-title" style="line-height: 18px">
						{{ geofenceCenterDetails ? geofenceCenterDetails.name : '' }}
					</div>
					<div class="imprs-containere">
						<span class="imprs-text">Impressions:</span>
						<span class="imprs-value">{{
							geofenceCenterDetails ? geofenceCenterDetails.total_impression_sum : ''
						}}</span>
					</div>
					<div class="imprs-containere">
						<span class="imprs-text">Clicks:</span>
						<span class="imprs-value">{{ geofenceCenterDetails ? geofenceCenterDetails.total_click_sum : '' }}</span>
					</div>
					<div class="imprs-containere">
						<span class="imprs-text">CTR:</span>
						<span class="imprs-value"
							>{{ geofenceCenterDetails ? geofenceCenterDetails.click_through_rate : '' }}%</span
						>
					</div>
					<div class="imprs-containere">
						<span class="imprs-text">Android:</span>
						<span class="imprs-value">{{ geofenceCenterDetails ? geofenceCenterDetails.total_android : '' }}%</span>
					</div>
					<div class="imprs-containere">
						<span class="imprs-text">iOS:</span>
						<span class="imprs-value">{{ geofenceCenterDetails ? geofenceCenterDetails.total_ios : '' }}%</span>
					</div>
				</div>
			</div>
			<div class="zoom-options-container">
				<div class="zoom-icon" (click)="zoomIn()">
					<i class="fa fa-plus" aria-hidden="true"></i>
				</div>
				<div class="zoom-icon" style="border-top: 0px" (click)="zoomOut()">
					<i class="fa fa-minus" aria-hidden="true"></i>
				</div>
			</div>
			<div class="lift-histogram-container" *ngIf="liftdistributionenabled">
				<app-lift-histogram
					[histogramData]="histogramData"
					[liftColor]="liftareacolor"
					(showLiftRegions)="showLiftRegions($event)"
					(hideLiftRegions)="hideLiftRegions()"
					(toggleLiftRegions)="toggleLiftRegions($event)"
					[barChartOptions]="barchartconfiguration"
					[isR8]="isR8 ? 'true' : 'false'"
				></app-lift-histogram>
			</div>
		</div>
		<!-- Geofence legends Container -->
		<div class="geoCenters-info" *ngIf="showGeofenceLegends">
			<div class="geoCenters-div geofence-div">
				<div class="geo-dot"></div>
				<div class="geo-values">Geo Recency</div>
			</div>
			<div class="geoCenters-div">
				<div class="recency-dot"></div>
				<div class="geo-values">Geofence</div>
			</div>
		</div>
		<div class="no-data-container" style="height: 580px" *ngIf="noData">
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>
</div>
